/* eslint-disable react/jsx-no-literals -- Allow hard-coded translations for now */
'use client'

import { type JSX } from 'react'

import { ProductPriceExplainerSection } from '../ProductPriceExplainerSection'

export const ProductPriceExplainerContentFr = (): JSX.Element => {
  return (
    <div className="flex flex-col gap-6">
      <ProductPriceExplainerSection>
        <p>
          Par rapport au prix moyen constaté sur un grand panel de pharmacie,
          TVA incluse.
        </p>
      </ProductPriceExplainerSection>
    </div>
  )
}
